import React from "react";

const DownloadIcon = (props: any) => {
  return (
    <>
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.33333 15.5834V13.75H14.6667V15.5834H7.33333ZM14.6667 9.16671L11 12.8334L7.33333 9.16671H9.625V5.50004H12.375V9.16671H14.6667ZM11 1.83337C16.0417 1.83337 20.1667 5.95837 20.1667 11C20.1667 16.0417 16.0417 20.1667 11 20.1667C5.95833 20.1667 1.83333 16.0417 1.83333 11C1.83333 5.95837 5.95833 1.83337 11 1.83337ZM11 3.66671C6.94833 3.66671 3.66667 6.94837 3.66667 11C3.66667 15.0517 6.94833 18.3334 11 18.3334C15.0517 18.3334 18.3333 15.0517 18.3333 11C18.3333 6.94837 15.0517 3.66671 11 3.66671Z"
          fill={props?.color ?? "#464646"}
        />
      </svg>
    </>
  );
};

export default DownloadIcon;
